// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__TqpTD","header":"Layout_header__JH1BO","menu":"Layout_menu__+lLvI","content":"Layout_content__N2xcu"};